// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-margin {
  margin: 0px;
}
.bk-picker {
  margin: 0 0 18px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}
.bk-picker .bk-picker-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.bk-picker .bk-picker-head .muted {
  margin-left: 8px;
}
.bk-picker .bk-picker-row {
  display: grid;
  grid-template-columns: 1fr auto auto auto;
  align-items: center;
  gap: 14px;
  padding: 10px 16px;
  border-bottom: 1px solid #f1f5f9;
}
.bk-picker .bk-picker-row:last-child {
  border-bottom: 0;
}
.bk-picker .bk-picker-row.added {
  background: #f0fdfa;
}
.bk-picker .bk-picker-row .what {
  min-width: 0;
}
.bk-picker .bk-picker-row .what strong,
.bk-picker .bk-picker-row .what .muted {
  display: block;
}
.bk-picker .bk-picker-row .amount {
  min-width: 90px;
  text-align: right;
}
.bk-picker .muted {
  color: #64748b;
  font-size: 0.8rem;
}
.bk-picker-empty {
  color: #64748b;
  font-size: 0.9rem;
  margin: 0 0 14px;
}
@media (max-width: 640px) {
  .bk-picker .bk-picker-row {
    grid-template-columns: 1fr auto;
  }
}
.svc-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0 0 14px;
}
.svc-bar .svc-label {
  margin-right: 4px;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}
.svc-bar .svc-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;
  color: #334155;
  font: inherit;
  font-size: 0.85rem;
  cursor: pointer;
}
.svc-bar .svc-chip i {
  font-size: 0.7rem;
  color: #0f766e;
}
.svc-bar .svc-chip:hover {
  border-color: #0f766e;
  background: #f0fdfa;
}
.svc-bar .svc-chip.other {
  border-style: dashed;
}
.billings-list .num {
  text-align: right;
}
.billings-list .line-title {
  font-weight: 600;
  color: #0f172a;
}
.billings-list .line-title i {
  margin-right: 6px;
  color: #0f766e;
}
.billings-list .line-meta {
  margin-top: 2px;
  font-size: 0.82rem;
  color: #64748b;
}
.billings-list .total {
  font-weight: 600;
  white-space: nowrap;
}
.billings-list .grand {
  font-size: 1.15rem;
  font-weight: 700;
}
.billings-list .empty-lines {
  padding: 22px 8px;
  text-align: center;
  color: #64748b;
}
.billings-list input[pInputText] {
  width: 100%;
}
/* amounts line up on the right under their column headings */
.billings-list th.num,
.billings-list td.num {
  text-align: right;
}
.billings-list .p-inputnumber {
  width: 100%;
}
.billings-list .p-inputnumber-input,
.billings-list td.num input {
  width: 100%;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.billings-list .total {
  font-variant-numeric: tabular-nums;
}
.billings-list .line-note {
  margin-top: 3px;
  font-size: 0.78rem;
  color: #b45309;
}
.billings-list .line-note i {
  margin-right: 4px;
}
/*# sourceMappingURL=billings-form.component.css.map */`, "",{"version":3,"sources":["webpack://./billings-form.component.less","webpack://./src/app/billings/billings-form/billings-form.component.less"],"names":[],"mappings":"AAEA;EACE,WAAA;ACDF;ADKA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;ACHF;ADFA;EAQI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;ACHJ;ADXA;EAiBM,gBAAA;ACHN;ADdA;EAsBI,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACLJ;ADOI;EACE,gBAAA;ACLN;ADQI;EACE,mBAAA;ACNN;AD5BA;EAsCM,YAAA;ACPN;AD/BA;;EA0CQ,cAAA;ACPR;ADnCA;EA+CM,eAAA;EACA,iBAAA;ACTN;ADvCA;EAqDI,cAAA;EACA,iBAAA;ACXJ;ADeA;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;ACbF;ADgBA;EACE;IACE,+BAAA;ECdF;AACF;ADiBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;ACfF;ADUA;EAQI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;ACfJ;ADEA;EAiBI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AChBJ;ADXA;EA8BM,iBAAA;EACA,cAAA;AChBN;ADmBI;EACE,qBAAA;EACA,mBAAA;ACjBN;ADoBI;EACE,oBAAA;AClBN;ADuBA;EAEI,iBAAA;ACtBJ;ADoBA;EAMI,gBAAA;EACA,cAAA;ACvBJ;ADgBA;EAUM,iBAAA;EACA,cAAA;ACvBN;ADYA;EAgBI,eAAA;EACA,kBAAA;EACA,cAAA;ACzBJ;ADOA;EAsBI,gBAAA;EACA,mBAAA;AC1BJ;ADGA;EA2BI,kBAAA;EACA,gBAAA;AC3BJ;ADDA;EAgCI,iBAAA;EACA,kBAAA;EACA,cAAA;AC5BJ;ADNA;EAsCI,WAAA;AC7BJ;AACA,6DAA6D;ADiC7D;;EAGI,iBAAA;AChCJ;AD6BA;EAOI,WAAA;ACjCJ;AD0BA;;EAYI,WAAA;EACA,iBAAA;EACA,kCAAA;AClCJ;ADoBA;EAkBI,kCAAA;ACnCJ;ADiBA;EAsBI,eAAA;EACA,kBAAA;EACA,cAAA;ACpCJ;ADYA;EA2BM,iBAAA;ACpCN;AACA,sDAAsD","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n.no-margin {\n  margin: 0px;\n}\n\n\n.bk-picker {\n  margin: 0 0 18px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: @white;\n  overflow: hidden;\n\n  .bk-picker-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 16px;\n    background: #f9fafb;\n    border-bottom: 1px solid #e5e7eb;\n\n    .muted {\n      margin-left: 8px;\n    }\n  }\n\n  .bk-picker-row {\n    display: grid;\n    grid-template-columns: 1fr auto auto auto;\n    align-items: center;\n    gap: 14px;\n    padding: 10px 16px;\n    border-bottom: 1px solid #f1f5f9;\n\n    &:last-child {\n      border-bottom: 0;\n    }\n\n    &.added {\n      background: #f0fdfa;\n    }\n\n    .what {\n      min-width: 0;\n\n      strong,\n      .muted {\n        display: block;\n      }\n    }\n\n    .amount {\n      min-width: 90px;\n      text-align: right;\n    }\n  }\n\n  .muted {\n    color: #64748b;\n    font-size: 0.8rem;\n  }\n}\n\n.bk-picker-empty {\n  color: #64748b;\n  font-size: 0.9rem;\n  margin: 0 0 14px;\n}\n\n@media (max-width: 640px) {\n  .bk-picker .bk-picker-row {\n    grid-template-columns: 1fr auto;\n  }\n}\n\n.svc-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 14px;\n\n  .svc-label {\n    margin-right: 4px;\n    font-size: 0.78rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: #64748b;\n  }\n\n  .svc-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    background: @white;\n    color: #334155;\n    font: inherit;\n    font-size: 0.85rem;\n    cursor: pointer;\n\n    i {\n      font-size: 0.7rem;\n      color: #0f766e;\n    }\n\n    &:hover {\n      border-color: #0f766e;\n      background: #f0fdfa;\n    }\n\n    &.other {\n      border-style: dashed;\n    }\n  }\n}\n\n.billings-list {\n  .num {\n    text-align: right;\n  }\n\n  .line-title {\n    font-weight: 600;\n    color: #0f172a;\n\n    i {\n      margin-right: 6px;\n      color: #0f766e;\n    }\n  }\n\n  .line-meta {\n    margin-top: 2px;\n    font-size: 0.82rem;\n    color: #64748b;\n  }\n\n  .total {\n    font-weight: 600;\n    white-space: nowrap;\n  }\n\n  .grand {\n    font-size: 1.15rem;\n    font-weight: 700;\n  }\n\n  .empty-lines {\n    padding: 22px 8px;\n    text-align: center;\n    color: #64748b;\n  }\n\n  input[pInputText] {\n    width: 100%;\n  }\n}\n\n/* amounts line up on the right under their column headings */\n.billings-list {\n  th.num,\n  td.num {\n    text-align: right;\n  }\n\n  .p-inputnumber {\n    width: 100%;\n  }\n\n  .p-inputnumber-input,\n  td.num input {\n    width: 100%;\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n  }\n\n  .total {\n    font-variant-numeric: tabular-nums;\n  }\n\n  .line-note {\n    margin-top: 3px;\n    font-size: 0.78rem;\n    color: #b45309;\n\n    i {\n      margin-right: 4px;\n    }\n  }\n}\n",".no-margin {\n  margin: 0px;\n}\n.bk-picker {\n  margin: 0 0 18px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #ffffff;\n  overflow: hidden;\n}\n.bk-picker .bk-picker-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n}\n.bk-picker .bk-picker-head .muted {\n  margin-left: 8px;\n}\n.bk-picker .bk-picker-row {\n  display: grid;\n  grid-template-columns: 1fr auto auto auto;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n.bk-picker .bk-picker-row:last-child {\n  border-bottom: 0;\n}\n.bk-picker .bk-picker-row.added {\n  background: #f0fdfa;\n}\n.bk-picker .bk-picker-row .what {\n  min-width: 0;\n}\n.bk-picker .bk-picker-row .what strong,\n.bk-picker .bk-picker-row .what .muted {\n  display: block;\n}\n.bk-picker .bk-picker-row .amount {\n  min-width: 90px;\n  text-align: right;\n}\n.bk-picker .muted {\n  color: #64748b;\n  font-size: 0.8rem;\n}\n.bk-picker-empty {\n  color: #64748b;\n  font-size: 0.9rem;\n  margin: 0 0 14px;\n}\n@media (max-width: 640px) {\n  .bk-picker .bk-picker-row {\n    grid-template-columns: 1fr auto;\n  }\n}\n.svc-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 14px;\n}\n.svc-bar .svc-label {\n  margin-right: 4px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #64748b;\n}\n.svc-bar .svc-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #334155;\n  font: inherit;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n.svc-bar .svc-chip i {\n  font-size: 0.7rem;\n  color: #0f766e;\n}\n.svc-bar .svc-chip:hover {\n  border-color: #0f766e;\n  background: #f0fdfa;\n}\n.svc-bar .svc-chip.other {\n  border-style: dashed;\n}\n.billings-list .num {\n  text-align: right;\n}\n.billings-list .line-title {\n  font-weight: 600;\n  color: #0f172a;\n}\n.billings-list .line-title i {\n  margin-right: 6px;\n  color: #0f766e;\n}\n.billings-list .line-meta {\n  margin-top: 2px;\n  font-size: 0.82rem;\n  color: #64748b;\n}\n.billings-list .total {\n  font-weight: 600;\n  white-space: nowrap;\n}\n.billings-list .grand {\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n.billings-list .empty-lines {\n  padding: 22px 8px;\n  text-align: center;\n  color: #64748b;\n}\n.billings-list input[pInputText] {\n  width: 100%;\n}\n/* amounts line up on the right under their column headings */\n.billings-list th.num,\n.billings-list td.num {\n  text-align: right;\n}\n.billings-list .p-inputnumber {\n  width: 100%;\n}\n.billings-list .p-inputnumber-input,\n.billings-list td.num input {\n  width: 100%;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n.billings-list .total {\n  font-variant-numeric: tabular-nums;\n}\n.billings-list .line-note {\n  margin-top: 3px;\n  font-size: 0.78rem;\n  color: #b45309;\n}\n.billings-list .line-note i {\n  margin-right: 4px;\n}\n/*# sourceMappingURL=billings-form.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
